import { useNavigate } from "react-router-dom";
import { useSettings } from "@/hooks/useContent";

// FontAwesome not bundled; use an inline WhatsApp glyph SVG.
export function WhatsAppFab() {
  const { data: s } = useSettings();
  const navigate = useNavigate();
  const number = (s?.whatsapp_number || "").replace(/[^0-9]/g, "");

  const onClick = () => {
    if (number) window.open(`https://wa.me/${number}`, "_blank", "noopener,noreferrer");
    else navigate("/iletisim");
  };

  return (
    <button
      data-testid="whatsapp-fab"
      onClick={onClick}
      aria-label={number ? "WhatsApp ile iletişime geç" : "İletişim sayfası"}
      className="fixed bottom-6 right-6 z-40 w-14 h-14 rounded-full bg-[#25D366] hover:bg-[#1ebe5b] shadow-lg shadow-black/30 flex items-center justify-center transition-transform duration-300 hover:scale-110"
    >
      <svg viewBox="0 0 24 24" className="w-7 h-7 fill-white" aria-hidden="true">
        <path d="M17.47 14.38c-.3-.15-1.76-.87-2.03-.97-.27-.1-.47-.15-.67.15-.2.3-.77.97-.94 1.17-.17.2-.35.22-.65.07-.3-.15-1.26-.46-2.4-1.48-.89-.79-1.49-1.77-1.66-2.07-.17-.3-.02-.46.13-.61.13-.13.3-.35.45-.52.15-.17.2-.3.3-.5.1-.2.05-.37-.02-.52-.07-.15-.67-1.62-.92-2.22-.24-.58-.49-.5-.67-.51h-.57c-.2 0-.52.07-.79.37-.27.3-1.04 1.02-1.04 2.48 0 1.46 1.06 2.87 1.21 3.07.15.2 2.09 3.2 5.08 4.49.71.31 1.26.49 1.69.63.71.23 1.36.2 1.87.12.57-.09 1.76-.72 2.01-1.41.25-.7.25-1.29.17-1.42-.07-.13-.27-.2-.57-.35zM12.04 2C6.58 2 2.13 6.45 2.13 11.91c0 1.75.46 3.45 1.32 4.95L2 22l5.25-1.38c1.45.79 3.08 1.21 4.79 1.21 5.46 0 9.91-4.45 9.91-9.91C21.95 6.45 17.5 2 12.04 2z" />
      </svg>
    </button>
  );
}
